
import { useEffect, useState } from 'react';
import CmsAPI from '../../../../common/apis/CmsAPI';

export default function useStoryComments({ storyId, commentsType, load }) {
    const commentInit = {
        authorName: '',
        content: '',
        parent: null,
        type: 3,
        username: '',
    };
    const [isCommentsLoading, setIsCommentsLoading] = useState(true);
    const [comments, setComments] = useState(null);
    const [newComment, setNewComment] = useState(commentInit);

    const loadComments = async () => {
        try {
            setIsCommentsLoading(true);
            const { result } = await CmsAPI.getComments(storyId, commentsType);
            setComments(result || []);
        } catch (err) {
            console.log(err);
            setComments([]);
        } finally {
            setIsCommentsLoading(false);
        }
    };

    useEffect(() => {
        load && loadComments();
    }, [load])

    return { isCommentsLoading, comments, newComment, commentInit, setNewComment, loadComments };
}
